import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOST } from "Constant/Constant";

export const siteConfigApi = createApi({
  reducerPath: "siteConfigApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),

  endpoints: (builder) => ({
    getSiteConfig: builder.query({
      query: (siteid) => ({
        url: `/site-config?siteid=${siteid}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    }),

    updateSiteConfig: builder.mutation({
      query: ({ body, siteId }) => ({
        url: "site-config/update",
        method: "PATCH",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          siteid: siteId,
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const { useGetSiteConfigQuery, useUpdateSiteConfigMutation } = siteConfigApi;
